// extracted by mini-css-extract-plugin
export default {"validationError":"SubscriptionGiftRecipientDetails_validationError__JfQcj"};